import { Box, TextField, TextInput } from "@flightstats/airframe-react";
import { testEmailAgainstRegex } from "../../../lib/airframe/FormValidation";
import _ from "lodash";
import React from "react";

type ContactPointsEmailFieldProps = {
    disabled: boolean;
    id: string;
    value: string;
    updateContactEmailInput: (value: string) => void;
    setIsEmailEmpty: (isEmpty: boolean) => void;
    setIsEmailInvalid: (isInvalid: boolean) => void;
};

export const ContactPointsEmailField: React.FC<ContactPointsEmailFieldProps> = ({
    disabled,
    id,
    value,
    updateContactEmailInput,
    setIsEmailEmpty,
    setIsEmailInvalid,
}) => (
    <Box className='contact-point-email-field'>
        <TextField>
            <TextInput
                label="Email Address"
                disabled={disabled}
                type="text"
                id={id}
                value={value}
                className='contact-point-email-field-text-input'
                max={320}
                onChange={value => {
                    setIsEmailEmpty(_.isEmpty(value));
                    updateContactEmailInput(value);
                    setIsEmailInvalid(!testEmailAgainstRegex(value));
                }}
                onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                    setIsEmailEmpty(_.isEmpty(e.currentTarget.value));
                }}
            />
        </TextField>
    </Box>
);